import { Pipe, PipeTransform } from '@angular/core';
import {ResourceQuery} from "../../resources/models/resource.query";

@Pipe({
  name: 'isUserSpecified'
})
export class IsUserSpecifiedPipe implements PipeTransform {

  transform(resourceQuery: ResourceQuery, userSpecifiedResourceIds: string[]): boolean {
    return userSpecifiedResourceIds.includes(resourceQuery.Id);
  }
}
